import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon Shield as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const Shield = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 48 48">
      <defs>
        <style>
          {
            '\n      .st0 {\n        fill: none;\n        stroke: #503291;\n        stroke-width: 1.5px;\n      }\n\n      .st1 {\n        fill: #e2f4ff;\n      }\n\n      .st2 {\n        fill: #503291;\n      }\n    '
          }
        </style>
      </defs>
      <path
        className="st1"
        d="M24,0h0c13.3,0,24,10.7,24,24h0c0,13.3-10.7,24-24,24h0C10.7,48,0,37.3,0,24h0C0,10.7,10.7,0,24,0Z"
      />
      <path
        className="st0"
        d="M24,8.8s0,0,0,0h0c.3.2.5.4.8.5h0c3.5,2.4,7.4,4.1,11.5,5.1h0s0,0,0,0,0,0,0,0v7.4c0,3.5-1,7-2.9,9.9-1.9,3-4.6,5.3-7.8,6.8h0c-.4.2-1,.4-1.5.6,0,0-.2,0-.3,0h0c-.2-.1-.5-.2-.7-.3l-.7-.3c-3.2-1.4-6-3.8-7.9-6.8-1.9-3-3-6.5-3-10v-7.4s0,0,0,0c0,0,0,0,0,0h0c4.2-1,8.1-2.8,11.6-5.2h0s0,0,0,0c.2-.2.3-.2.6-.4h0s0,0,0,0Z"
      />
      <path
        className="st0"
        d="M24,17.9c3.2,0,5.7,2.6,5.7,5.7,0,3.2-2.6,5.7-5.7,5.7-3.2,0-5.7-2.6-5.7-5.7,0-3.2,2.6-5.7,5.7-5.7Z"
      />
      <path
        className="st2"
        d="M23.8,25.9l3.6-3.4c.1-.1.2-.3.2-.4,0-.2,0-.3-.2-.4-.1-.1-.3-.2-.4-.2-.2,0-.3,0-.4.2l-3.1,3-1.4-1.5c-.1-.1-.3-.2-.4-.2-.2,0-.3,0-.4.2-.1.1-.2.3-.2.4,0,.2,0,.3.2.4l1.8,1.9c.1.1.3.2.4.2.2,0,.3,0,.4-.2h0Z"
      />
    </Icon>
  )
}
export default Shield
